export default "__VITE_ASSET__DW0g1Orc__"